import { BookingOnLoadRes } from "entities/Form";

export const getSystemMessage = (
  bookingOnLoadData?: BookingOnLoadRes,
): string | undefined => bookingOnLoadData?.systemMessage?.trim() || undefined;

export const canContinueBookingWithNotice = (
  systemMessage: string | undefined,
  hasBookingOptions: boolean,
): boolean =>
  hasBookingOptions &&
  /typhoon|extreme\s+(?:conditions|weather)|颱風|台风|極端(?:情況|天氣)|极端(?:情况|天气)/i.test(systemMessage || "");
